var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 125,
    viewBox: "0 0 160 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.697266 3C0.697266 1.34315 2.03207 0 3.67863 0H156.722C158.369 0 159.703 1.34315 159.703 3V23.163H0.697266V3ZM0.697266 24.163H159.703V121.082C159.703 122.738 158.369 124.082 156.722 124.082H3.67863C2.03208 124.082 0.697266 122.738 0.697266 121.082V24.163ZM27.6211 15.7258C29.8166 15.7258 31.5963 13.9228 31.5963 11.6986C31.5963 9.47444 29.8166 7.67139 27.6211 7.67139C25.4258 7.67139 23.646 9.47444 23.646 11.6986C23.646 13.9228 25.4258 15.7258 27.6211 15.7258ZM11.7253 15.7265C13.9208 15.7265 15.7004 13.9235 15.7004 11.6993C15.7004 9.47517 13.9208 7.67212 11.7253 7.67212C9.5299 7.67212 7.75017 9.47517 7.75017 11.6993C7.75017 13.9235 9.5299 15.7265 11.7253 15.7265ZM47.4979 11.6986C47.4979 13.9228 45.7181 15.7258 43.5228 15.7258C41.3273 15.7258 39.5476 13.9228 39.5476 11.6986C39.5476 9.47444 41.3273 7.67139 43.5228 7.67139C45.7181 7.67139 47.4979 9.47444 47.4979 11.6986Z",
    fill: "url(#paint0_linear_347_28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.902 92.5613H142.982",
    stroke: "#B1B1B1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7773 92.5613H61.8563",
    stroke: "#B1B1B1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7965 88.1633H14.6715C14.1227 88.1633 13.6777 88.611 13.6777 89.1633V95.3266C13.6777 95.8789 14.1227 96.3266 14.6715 96.3266H20.7965C21.3454 96.3266 21.7903 95.8789 21.7903 95.3266V89.1633C21.7903 88.611 21.3454 88.1633 20.7965 88.1633Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.922 88.1633H95.7965C95.2477 88.1633 94.8027 88.611 94.8027 89.1633V95.3266C94.8027 95.8789 95.2477 96.3266 95.7965 96.3266H101.922C102.47 96.3266 102.915 95.8789 102.915 95.3266V89.1633C102.915 88.611 102.47 88.1633 101.922 88.1633Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.902 110.52H142.982",
    stroke: "#B1B1B1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7773 110.52H61.8563",
    stroke: "#B1B1B1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7965 106.122H14.6715C14.1227 106.122 13.6777 106.57 13.6777 107.122V113.285C13.6777 113.838 14.1227 114.285 14.6715 114.285H20.7965C21.3454 114.285 21.7903 113.838 21.7903 113.285V107.122C21.7903 106.57 21.3454 106.122 20.7965 106.122Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.922 106.122H95.7965C95.2477 106.122 94.8027 106.57 94.8027 107.122V113.285C94.8027 113.838 95.2477 114.285 95.7965 114.285H101.922C102.47 114.285 102.915 113.838 102.915 113.285V107.122C102.915 106.57 102.47 106.122 101.922 106.122Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3008 46.8469H112.154",
    stroke: "#E7E7E7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3008 53.3777H142.983",
    stroke: "#E7E7E7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3008 59.9082H142.983",
    stroke: "#E7E7E7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9258 76.4846H143.23",
    stroke: "#A7A7A7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9682 39.1836H15.6653C14.5676 39.1836 13.6777 40.079 13.6777 41.1836V64.9387C13.6777 66.0433 14.5676 66.9387 15.6653 66.9387H74.9682C76.0659 66.9387 76.9557 66.0433 76.9557 64.9387V41.1836C76.9557 40.079 76.0659 39.1836 74.9682 39.1836Z",
    fill: "url(#paint1_linear_347_28)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_28",
    x1: 0.694093,
    y1: 112,
    x2: 76.9034,
    y2: -9.30209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717186",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_28",
    x1: 45.3168,
    y1: 39.1836,
    x2: 45.3168,
    y2: 66.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.39793e7bd35d807a20d83adc00dcaddb.svg";
export { ForwardRef as ReactComponent };